'use strict';

var accesories = function () {
  var jsonData = void 0;
  var _load = function _load(moi) {
    $.getJSON(globalEnv + 'servicios/getaccesorios?moi=' + moi + '&categoria=destacados&mercado=ES', function (data) {
      return jsonData = data;
    }).done(function () {
      _makeItemsList(jsonData);
      $('.js-accesories-btn').addClass('js-data-loaded');
    });
  };

  var accesor_item_html = function accesor_item_html(data) {
    var desc = typeof data.descripcion !== 'undefined' ? '<p class="accesories_as-p">' + data.descripcion + '</p>' : '';
    return '\n  <article class="accesories_as accesories_as-4cols">\n    <figure class="accesories_as-fg ">\n      <img class="img" alt="" src="' + globalEnvStatic + data.imagen + '" />\n    </figure>\n    <div class="accesories_as-character">\n      <h3 class="title">' + data.nombre + '</h3>\n      ' + desc + '\n      <p class="accesories_as-p">' + data.referencia + ' - DESDE ' + Math.round(data.precio) + '\u20AC</p>\n    </div>\n  </article>\n  ';
  };

  var _makeItemsList = function _makeItemsList(json) {
    $('.js-accesories-list').empty();
    for (var i = 0; json[i]; i++) {
      utils.render(accesor_item_html(json[i]), '.js-accesories-list');
    }
  };

  return {
    load: _load
  };
}();